/**
 * Marketing/SSG analytics helpers. Event capture goes through PostHog
 * (`usePostHog().capture(...)`) following the existing snake_case convention;
 * attach `getAttributionProps()` from '@/lib/attribution' to marketing events.
 *
 * `render_mode` is NOT added per event — it's injected onto every event by the
 * `before_send` hook in src/routes/__root.tsx (see getRenderMode below).
 */

declare global {
  interface Window {
    /** Set by the prerender step (scripts/prerender.mjs) on SSG documents. */
    __BOUNDR_PRERENDER_PATH__?: string;
  }
}

export const MARKETING_EVENTS = {
  pageViewed: 'marketing_page_viewed',
  navClicked: 'marketing_nav_clicked',
  sectionViewed: 'marketing_section_viewed',
  scrollDepth: 'marketing_scroll_depth',
} as const;

/** Marketing routes (kept in sync with prerender.config.ts PRERENDER_ROUTES). */
export const MARKETING_PATHS = ['/', '/land-monitoring', '/about', '/contact-us'];

export function isMarketingPath(path: string): boolean {
  return MARKETING_PATHS.includes(path);
}

/**
 * 'ssg' when the current document was served from prerendered HTML for this exact
 * path, else 'csr' (client navigation, or a CSR route served the SPA shell).
 */
export function getRenderMode(): 'ssg' | 'csr' {
  if (typeof window === 'undefined') return 'csr';
  return window.__BOUNDR_PRERENDER_PATH__ === window.location.pathname ? 'ssg' : 'csr';
}
